import useBonusRewardCardState from '@/hooks/bonus/useBonusRewardCardState';
import { Image } from '@starsoft/common/components';
import { m } from 'framer-motion';
import { memo } from 'react';
import RewardSubmitButton from '../../SubmitButton';
import { BonusClaimRewardModalContentRewardCardProps } from './props';
import BonusClaimRewardModalContentRewardCardSkeleton from './Skeleton';
import styles from './styles.module.scss';
import { variants } from './varitants';

function BonusClaimRewardModalContentRewardCard({
  isLoading,
  userReward,
  rewardId,
}: BonusClaimRewardModalContentRewardCardProps) {
  const {
    description,
    dynamicReward,
    icon,
    isLevelUpReward,
    formattedValue,
    title,
    countdown,
    isNegativeRewardAmount,
  } = useBonusRewardCardState({ userReward, rewardId });

  if (isLoading) {
    return <BonusClaimRewardModalContentRewardCardSkeleton />;
  }

  return (
    <m.div className={styles.card} exit="exit" variants={variants}>
      {isLevelUpReward && (
        <Image
          className={styles.card__icon}
          width={80}
          height={80}
          preload
          src={icon}
          alt="rank"
          secondarySkeleton
        />
      )}
      <div className={styles.card__column}>
        <div className={styles.card__column__title}>{title}</div>
        <div className={styles.card__column__description}>{description}</div>
        <div className={styles.card__column__coin__chip}>
          <Image
            width={15}
            height={15}
            alt={`coin-image-${dynamicReward?.coin?.name}`}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${dynamicReward?.coin?.image}`}
          />
          <div
            className={`${styles.card__column__coin__label} ${isNegativeRewardAmount ? styles['card__column__coin__label--negative'] : ''}`}
          >
            {formattedValue}
          </div>
        </div>
      </div>
      <RewardSubmitButton
        countdown={countdown}
        isLoadingClaimUserReward={false}
        reward={userReward?.reward}
        userReward={userReward}
        dynamicReward={dynamicReward as any}
      />
    </m.div>
  );
}

export default memo(BonusClaimRewardModalContentRewardCard);
